import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=67d20d42&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=ts"
export * from "./BlogCard.vue?vue&type=script&lang=ts"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=67d20d42&prod&lang=css"
import style1 from "./BlogCard.vue?vue&type=style&index=1&id=67d20d42&prod&scoped=true&lang=css"
import style2 from "./BlogCard.vue?vue&type=style&index=2&id=67d20d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d20d42",
  null
  
)

export default component.exports